module.exports = __webpack_public_path__ + "img/xcp.37cecc8f.svg";